module.exports = __webpack_public_path__ + "img/icon_mission.9cfffb0b.svg";